import React from "react";

import { clsx } from "clsx";

const styles = {
  H1: `font-display text-h1 leading-h1 xl:text-[56px]`,
  H2: `font-display text-h2 leading-h2 md:text-[32px] xl:text-[44px]`,
  H3: `font-display text-h4 leading-h3 md:text-[32px]`,
  H4: `font-body text-h3 leading-h4 font-medium`,
  H5: `font-body text-hint leading-h5 tracking-heading uppercase pb-pico`,
  P: `font-body text-body leading-body`,
  Small: `font-body text-hint leading-hint`,
  XSmall: `font-body text-caption leading-hint`,
  Underline: `block border-b pb-nano`,
  UnderlineDisabled: `block pb-nano`,
  UnderlineSmall: `border-b pb-[1px] leading-body block`,
  UnderlineSmallDisabled: `pb-[1px] leading-body block`,
};

export const StyledH1 = (props: any) => (
  <h1 {...props} className={clsx(props.className, styles.H1)} />
);

export const StyledH2 = (props: any) => (
  <h2 {...props} className={clsx(props.className, styles.H2)} />
);

export const StyledH3 = (props: any) => (
  <h3 {...props} className={clsx(props.className, styles.H3)} />
);

export const StyledH4 = (props: any) => (
  <h4 {...props} className={clsx(props.className, styles.H4)} />
);

export const StyledH5 = (props: any) => (
  <h5 {...props} className={clsx(props.className, styles.H5)} />
);

export const StyledP = (props: any) => (
  <p {...props} className={clsx(props.className, styles.P)} />
);

export const StyledSmall = (props: any) => (
  <p {...props} className={clsx(props.className, styles.Small)} />
);

export const StyledXSmall = (props: any) => (
  <p {...props} className={clsx(props.className, styles.XSmall)} />
);

export const UnderlineText = (props: any) => (
  <span
    {...props}
    className={clsx(
      props.className,
      props.disabled ? styles.UnderlineDisabled : styles.Underline,
    )}
  />
);

export const UnderlineTextSmall = (props: any) => (
  <span
    {...props}
    className={clsx(
      props.className,
      props.disabled ? styles.UnderlineSmallDisabled : styles.UnderlineSmall,
    )}
  />
);
